import React from 'react';
import { Button, Tooltip } from '@mui/material';

/**
 * Reusable Icon Button Control for ReportHeader
 * Supports different variants and themes
 */
export default function IconButtonControl({
  icon: IconComponent,
  onClick,
  disabled = false,
  tooltip = '',
  variant = 'default',
  size = 'medium',
  ...props
}) {
  const getVariantStyles = (variant) => {
    const variants = {
      default: {
        backgroundColor: '#1976d2',
        color: '#ffffff',
        borderColor: '#1976d2',
        '&:hover': {
          backgroundColor: '#1565c0',
          borderColor: '#1565c0',
        }
      },
      yellow: {
        backgroundColor: '#f1c40f !important',
        color: '#2c3e50 !important',
        borderColor: '#2c3e50',
        '&:hover': { 
          backgroundColor: '#f39c12 !important',
          color: '#2c3e50 !important',
          borderColor: '#2c3e50',
        },
        '&:focus': { 
          backgroundColor: '#f1c40f !important',
          color: '#2c3e50 !important',
          borderColor: '#2c3e50',
        },
        '&:active': { 
          backgroundColor: '#f39c12 !important',
          color: '#2c3e50 !important',
          borderColor: '#2c3e50',
        },
        '&.Mui-focusVisible': { 
          backgroundColor: '#f1c40f !important',
          color: '#2c3e50 !important',
          borderColor: '#2c3e50',
        },
      },
      titleColor: {
        backgroundColor: '#cf9e0b !important',
        color: '#29261f !important',
        borderColor: '#29261f',
        '&:hover': { 
          backgroundColor: '#b8890a !important',
          color: '#29261f !important',
          borderColor: '#29261f',
        },
        '&:focus': { 
          backgroundColor: '#cf9e0b !important',
          color: '#29261f !important',
          borderColor: '#29261f',
        },
        '&:active': { 
          backgroundColor: '#b8890a !important',
          color: '#29261f !important',
          borderColor: '#29261f',
        },
        '&.Mui-focusVisible': { 
          backgroundColor: '#cf9e0b !important',
          color: '#29261f !important',
          borderColor: '#29261f',
        },
      },
      red: {
        backgroundColor: '#e74c3c',
        color: '#ffffff',
        borderColor: '#e74c3c',
        '&:hover': {
          backgroundColor: '#c0392b',
          borderColor: '#c0392b',
        }
      },
      green: {
        backgroundColor: '#27ae60',
        color: '#ffffff',
        borderColor: '#27ae60',
        '&:hover': {
          backgroundColor: '#229954',
          borderColor: '#229954',
        }
      }
    };
    
    return variants[variant] || variants.default;
  };

  const button = (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      size={size}
      sx={{
        minWidth: 'auto',
        padding: size === 'small' ? '6px 10px' : '8px 12px',
        ...getVariantStyles(variant)
      }}
      {...props}
    >
      {IconComponent && <IconComponent />}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={tooltip}>
      {button}
    </Tooltip>
  ) : button;
}